import { ROUTES } from "routing/routes";

export function linkToReassign(classId?: string, assignmentId?: string) {
  if (classId && assignmentId) {
    return `${ROUTES.TEACHER.CLASS.ASSIGNMENTS.ASSIGNMENT.buildPath({
      classId,
      assignmentId
    })}/reassign`;
  }

  return `${ROUTES.TEACHER.CLASS.ASSIGNMENTS.ASSIGNMENT.path}/reassign`;
}

export function linkToSelectSectionStats(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToReassign(classId, assignmentId)}/section`;
}

export function linkToPickDueDate(classId?: string, assignmentId?: string) {
  return `${linkToReassign(classId, assignmentId)}/due`;
}
